import { maskitoParseNumber } from '@maskito/kit'

export function parseCurrencyValue(value: string): number {
  const parsed = maskitoParseNumber(value, { decimalSeparator: '.' })
  return isNaN(parsed) ? 0 : parsed
}
